<template>
  <div class="home">
    <img class="home-logo" src="../../assets/home/logo_new_blue.png" />
    <div class="home-slogan">加入你的专属社群<br />获取社群专享权益</div>

    <div class="home-bottom-container">
      <img class="tag-container" src="../../assets/home/benefit_home.png" />
      <div class="confirm-btn" @click="onBtnClick">
        <span class="confirm-btn-title">即刻入群</span>
      </div>
    </div>
  </div>
</template>

<script>
import share from "../../_mixins/share";

export default {
  name: "home_page",
  mixins: [share],
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {
    // 处理微信分享
    this.wxShare();
  },
  methods: {
    /**
     * 页面事件
     */
    onBtnClick() {
      this.$router.push({ name: "store_page" });
    },
  },
};
</script>

<style lang="less" scoped>
@import "./home.less";
</style>
